module.exports = __webpack_public_path__ + "static/media/_MIC2362.thumbnail.912b8c63.png";